import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { useSelector } from 'react-redux'
import { PDFDownloadLink } from '@react-pdf/renderer'

import { CircularProgress } from '@mui/material'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'

import moment from 'moment'
import 'moment/locale/es'

import NumberFormat from 'react-number-format'

import './vistaPrevia.css'
import { Model } from '../../../models/model'
import { PdfFileNP } from './PdfFileNP'
import { VistaPreviaPrintNP } from './VistaPreviaPrintNP'

export const VistaPreviaNP = ({ open, setOpen }) => {

    const auth = useSelector(state => state.auth)
    const infoEmp = useSelector(state => state.general.info)
    const infoGeneral = useSelector(state => state.general.detail)
    const { nombre_columna_dias, pdf_color_formato } = infoGeneral
    const { url_foto } = infoEmp

    const dataPreview = useSelector(state => state.ppto.detail)
    const progress = false
    const [openPrint, setOpenPrint] = useState(false)

    const viewOptions = {
        ocultar_montos_items: false,
        ver_solo_subtotal_item: false,
        ver_solo_titulos: false,
        ver_total_con_impuestos: true,
        ocultar_texto_igv: false
    }

    const params = useParams()
    const { budgetId: idPresupuesto } = params

    const { separacion_miles, separacion_decimales, simbolo, sub_total, descuento, total_cliente, total, total_impuesto, porcentaje_impuesto, descuento_porcentaje, validacion_estado } = dataPreview

    const handleClose = () => {
        setOpen(false);
    };

    const descriptionElementRef = React.useRef(null);
    const { current: descriptionElement } = descriptionElementRef;

    useEffect(() => {
        if (open) {
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open, descriptionElement]);

    const handleDowload = async () => {

        await Model.save({
            url: 'ppto_versiones',
            dataForm: {
                id_ppto: idPresupuesto,
                data_version: JSON.stringify(dataPreview)
            }
        })

        document.getElementById(`btn-descargar-pdf`).click()
    }

    const handlePrint = async () => {
        setOpenPrint(true)
    }

    return (
        <div>
            <Dialog
                className='ContainerModalVistaPrevia'
                open={open}
                onClose={handleClose}
                scroll={'paper'}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogTitle
                    className='ColorTitleDocument'
                    id="scroll-dialog-title">
                    <IconButton
                        aria-label="close"
                        style={{ padding: '0', float: 'right' }}
                        onClick={() => setOpen(false)}
                    >
                        <CloseIcon style={{ color: '#78667E' }} />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers className='DialogContentVistaPrevia'>

                    {(validacion_estado === 'por validar' || validacion_estado === 'requiere' || validacion_estado === 'solicitado') &&
                        < div className='copia-no-valida'>
                            <h2>Copia no válida</h2>
                            <h3>( presupuesto pendiente de validar )</h3>
                        </div>
                    }

                    <div className='ContainerPresupuesto'>
                        <section className='Section1Presupuesto'>
                            <section>
                                <div>
                                    <div>
                                        {pdf_color_formato ?
                                            <h1 className='TitleModal' style={{ color: pdf_color_formato, textTransform: 'uppercase' }}>
                                                NOTA DE PEDIDO
                                            </h1>
                                            :
                                            <h1 className='ColorPrimary TitleModal' style={{ textTransform: 'uppercase' }}>
                                                NOTA DE PEDIDO
                                            </h1>
                                        }
                                        <p className='SubTitle ColorTitleDocument '>{`#0000${dataPreview.numero}`}</p>
                                    </div>
                                    <div style={{ position: 'relative' }}>
                                        <section className='ContainerLogoEmpresa'>
                                            <img
                                                src={url_foto}
                                                alt="Logo empresa"
                                            />
                                        </section>
                                    </div>
                                </div>

                                <p className='SubTitle ColorTitleDocument '>{moment(new Date()).format('DD MMMM YYYY')}</p>

                                {(dataPreview?.nro_version_actual > 0) &&
                                    <p className='ColorTitleDocument'>Versión {dataPreview?.nro_version_actual}</p>
                                }

                                <section className='InfoGeneralPpto'>
                                    <div>
                                        <p>Cliente : </p>
                                        <p style={{ textTransform: 'uppercase' }}>{dataPreview?.cliente || '--'}</p>
                                    </div>

                                    {dataPreview?.razon_social &&
                                        <div>
                                            <p>Razón social : </p>
                                            <p style={{ textTransform: 'uppercase' }}>{dataPreview?.razon_social || '--'}</p>
                                        </div>
                                    }

                                    {dataPreview?.direccion &&
                                        <div>
                                            <p>Dirección : </p>
                                            <p style={{ textTransform: 'uppercase' }}>{dataPreview?.direccion || '--'}</p>
                                        </div>
                                    }

                                    <div style={{ marginTop: '10px' }}>
                                        <p>Contacto cliente : </p>
                                        <p style={{ textTransform: 'uppercase' }}>{dataPreview?.contacto_nombre || '--'}</p>
                                    </div>
                                    <div>
                                        <p>Email contacto : </p>
                                        <p style={{ textTransform: 'uppercase' }}>{dataPreview?.contacto_email || '--'}</p>
                                    </div>
                                    <div>
                                        <p>Ejecutivo : </p>
                                        <p style={{ textTransform: 'uppercase' }}>{`${dataPreview?.nombre_ejecutivo_completo}`}</p>
                                    </div>
                                </section>

                            </section>

                        </section>
                        <section className='Section2Presupuesto'>
                            <section>
                                <h1 className='ColorTitleDocument TitleSection2 Uppercase'>{dataPreview.referencia}</h1>
                                <section className='InfoGeneralPpto'>

                                    <TablaPresupuesto
                                        dataPreview={dataPreview}
                                        viewOptions={viewOptions}
                                        nombre_columna_dias={nombre_columna_dias}
                                    />

                                    <section className='row InfoFinalPpto'>

                                        <div className='col-7'></div>
                                        <div className='col-5 p-bloque-total'>

                                            {descuento > 0 &&
                                                <div className='row'>
                                                    <div className='col-6'><label className='p-label-total'>SUBTOTAL</label></div>
                                                    <div className='col-6'>
                                                        <NumberFormat
                                                            className='p-label-total-monto'
                                                            value={sub_total}
                                                            displayType={'text'}
                                                            thousandSeparator={separacion_miles}
                                                            decimalSeparator={separacion_decimales}
                                                            prefix={`${simbolo} `}
                                                            decimalScale={2}
                                                        />
                                                    </div>
                                                </div>
                                            }

                                            {descuento > 0 &&
                                                <div className='row'>
                                                    <div className='col-6'>
                                                        <label className='p-label-total'>
                                                            ( {descuento_porcentaje}% )<span className='ms-2'>DESC</span>
                                                        </label>
                                                    </div>
                                                    <div className='col-6'>
                                                        <NumberFormat
                                                            className='p-label-total-monto'
                                                            value={descuento}
                                                            displayType={'text'}
                                                            thousandSeparator={separacion_miles}
                                                            decimalSeparator={separacion_decimales}
                                                            prefix={`${simbolo} `}
                                                            decimalScale={2}
                                                        />
                                                    </div>
                                                </div>
                                            }

                                            <div className='row'>
                                                <div className='col-6'>
                                                    <label className='p-label-total'>
                                                        {viewOptions.ocultar_texto_igv ? 'TOTAL' : 'TOTAL NETO'}
                                                    </label>
                                                </div>
                                                <div className='col-6 p-total-base'>
                                                    <NumberFormat
                                                        className='p-label-total-monto'
                                                        value={total_cliente}
                                                        displayType={'text'}
                                                        thousandSeparator={separacion_miles}
                                                        decimalSeparator={separacion_decimales}
                                                        prefix={`${simbolo} `}
                                                        decimalScale={2}
                                                    />
                                                </div>
                                            </div>

                                            {viewOptions.ver_total_con_impuestos &&
                                                <>
                                                    <div className='row'>
                                                        <div className='col-6'>
                                                            <label className='p-label-total'>
                                                                ( {porcentaje_impuesto}% )<span className='ms-2'>IGV</span>
                                                            </label>
                                                        </div>
                                                        <div className='col-6'>
                                                            <NumberFormat
                                                                className='p-label-total-monto'
                                                                value={total_impuesto}
                                                                displayType={'text'}
                                                                thousandSeparator={separacion_miles}
                                                                decimalSeparator={separacion_decimales}
                                                                prefix={`${simbolo} `}
                                                                decimalScale={2}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='row'>
                                                        <div className='col-6'><label className='p-label-total'>TOTAL</label></div>
                                                        <div className='col-6'>
                                                            <NumberFormat
                                                                className='p-label-total-monto'
                                                                value={total}
                                                                displayType={'text'}
                                                                thousandSeparator={separacion_miles}
                                                                decimalSeparator={separacion_decimales}
                                                                prefix={`${simbolo} `}
                                                                decimalScale={2}
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            }

                                            {(!viewOptions.ver_total_con_impuestos && !viewOptions.ocultar_texto_igv) &&
                                                <div className='row'>
                                                    <div className='col-12'>
                                                        <p className='label-igv'>No incluye IGV</p>
                                                    </div>
                                                </div>
                                            }

                                        </div>

                                    </section>
                                </section>
                            </section>
                        </section>

                        <section className='Section3Presupuesto' style={{ marginTop: '20px' }}>

                            {pdf_color_formato ?
                                <h1
                                    className='ColorTitleDocument TitleSection2'
                                    style={{
                                        borderBottom: pdf_color_formato ? `2px solid ${pdf_color_formato}` : '2px solid var(--primary-color)',
                                        paddingBottom: '5px',
                                        fontWeight: '600',
                                        marginTop: '7px'
                                    }}
                                >CONDICIONES</h1>
                                :
                                <h1 className='ColorTitleDocument TitleSection2 TitleSection3'>CONDICIONES</h1>
                            }

                            <section>
                                <div className='ObservacionesPpto2'>
                                    <div>
                                        <p>Moneda: </p>
                                        <p style={{ textTransform: 'capitalize' }}>{dataPreview?.moneda || '--'}</p>
                                    </div>
                                    <div>
                                        <p>Forma de pago: </p>
                                        <p>{dataPreview?.forma_pago || '--'}</p>
                                    </div>

                                    {(dataPreview?.observaciones && dataPreview?.observaciones !== '') &&
                                        <div className='block-obs'>
                                            <p>Observaciones: </p>
                                            <p className='block-obs-text'>{dataPreview?.observaciones}</p>
                                        </div>
                                    }

                                    {(dataPreview?.terminos_condiciones && dataPreview?.terminos_condiciones !== '') &&
                                        <div className='block-obs'>
                                            <p className='block-obs-label'>Términos y condiciones: </p>
                                            <p className='block-obs-text'>{dataPreview?.terminos_condiciones}</p>
                                        </div>
                                    }

                                </div>
                            </section>


                            {/* <section>
                                <p className='p-np-observaciones'>
                                    <pre>
                                        {terminos_condiciones || '--'}
                                    </pre>
                                </p>
                            </section> */}

                        </section>

                        <section className='p-np-firmas'>
                            <div className='clientes'>Firma y Sello Cliente (Directo)</div>
                            <div className='medios'>Central de Medios</div>
                            <div className='ejecutivo'>Ejecutivo Comercial</div>
                        </section>

                    </div>
                </DialogContent>

                <DialogActions className='DialogActionVistaPrevia'>
                    <Button
                        className='p-btn-secondary'
                        variant="contained"
                        size='medium'
                        type='button'
                        onClick={handleDowload}
                    >
                        Descargar
                        {progress && <CircularProgress className='CircularProgress' />}
                    </Button>

                    <Button
                        className='p-btn-primary'
                        variant="contained"
                        size='medium'
                        type='button'
                        onClick={handlePrint}
                    >
                        Imprimir
                    </Button>
                </DialogActions>

                {openPrint &&
                    <VistaPreviaPrintNP
                        auth={auth}
                        infoEmp={infoEmp}
                        dataPreview={dataPreview}
                        viewOptions={viewOptions}
                        open={openPrint}
                        setOpen={setOpenPrint}
                        urlLogo={url_foto}
                        nombre_columna_dias={nombre_columna_dias}
                        infoGeneral={infoGeneral}
                    />
                }

                <div style={{ display: 'none' }}>
                    <PDFDownloadLink
                        document={
                            <PdfFileNP
                                auth={auth}
                                infoEmp={infoEmp}
                                dataPreview={dataPreview}
                                viewOptions={viewOptions}
                                urlLogo={url_foto}
                                nombre_columna_dias={nombre_columna_dias}
                                infoGeneral={infoGeneral}
                            />
                        }
                        fileName="ppto.pdf"
                    >
                        <button id="btn-descargar-pdf" type="button">descargar</button>
                    </PDFDownloadLink>

                </div>
            </Dialog>
        </div >
    );
}

const TablaPresupuesto = ({ dataPreview, viewOptions, nombre_columna_dias }) => {

    const { separacion_miles, separacion_decimales, simbolo, nombre_columna_dias: columnName } = dataPreview
    const { pdf_color_formato } = useSelector(state => state.general.detail)

    return (
        <table className="table table-vista-previa">
            <thead>
                <tr
                    className='text-center'
                    style={{ borderBottom: pdf_color_formato ? `2px solid ${pdf_color_formato}` : '2px solid var(--primary-color)' }}
                >
                    <th scope="col" className='text-start'>Ítems</th>
                    {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) && <th scope="col">Cant.</th>}
                    {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) && <th scope="col">{columnName || 'Días'}</th>}
                    {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item && !viewOptions.ver_solo_titulos) && <th scope="col">Unid</th>}
                    {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) && <th scope="col" className='text-end'>P. Unitario</th>}
                    {!viewOptions.ocultar_montos_items && <th scope="col" className='text-end'>Subtotal</th>}

                    {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) && <th scope="col" className='text-end'>Dscto.</th>}
                    {!viewOptions.ocultar_montos_items && <th scope="col" className='text-end'>Total</th>}
                </tr>
            </thead>
            <tbody>
                {dataPreview?.items?.map((title, index) => {
                    return (
                        <>
                            <tr><td colSpan={6}></td></tr>
                            <tr className='text-center title' key={title.id}>
                                <td className='text-start'>{title.nombre}</td>
                                {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) && <td></td>}
                                {/* {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) && <td>{title.cant}</td>} */}
                                {/* {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) && <td>{title.dias}</td>} */}
                                {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) && <td></td>}
                                {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item && !viewOptions.ver_solo_titulos) && <td></td>}

                                {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) &&
                                    <td className='text-end'>
                                        <NumberFormat
                                            value={title.precio_unitario || 0}
                                            displayType={'text'}
                                            thousandSeparator={separacion_miles}
                                            decimalSeparator={separacion_decimales}
                                            prefix={`${simbolo} `}
                                        />
                                    </td>
                                }
                                {!viewOptions.ocultar_montos_items &&
                                    <td className='text-end'>
                                        <NumberFormat
                                            value={title.pre_subtotal_precio || 0}
                                            displayType={'text'}
                                            thousandSeparator={separacion_miles}
                                            decimalSeparator={separacion_decimales}
                                            prefix={`${simbolo} `}
                                        />
                                    </td>
                                }

                                {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) &&
                                    <td className='text-end'>
                                        <NumberFormat
                                            value={title.descuento || 0}
                                            displayType={'text'}
                                            thousandSeparator={separacion_miles}
                                            decimalSeparator={separacion_decimales}
                                            prefix={`${simbolo} `}
                                        />
                                    </td>
                                }
                                {!viewOptions.ocultar_montos_items &&
                                    <td className='text-end'>
                                        <NumberFormat
                                            value={title.precio_subtotal || 0}
                                            displayType={'text'}
                                            thousandSeparator={separacion_miles}
                                            decimalSeparator={separacion_decimales}
                                            prefix={`${simbolo} `}
                                        />
                                    </td>
                                }

                            </tr>
                            {title.items?.map((item, index2) => (
                                <tr key={index2} className='text-center' style={{ display: viewOptions.ver_solo_titulos ? 'none' : '' }}>
                                    <td className='text-start'>
                                        <div className="item-name">
                                            <label>{index2 + 1}.</label>
                                            <label style={{ marginLeft: '15px' }}>{item.nombre}</label>
                                        </div>
                                        {(item.descripcion_larga && item.descripcion_larga !== '') &&
                                            <div className="item-name-detalle">
                                                <pre style={{ textTransform: 'none' }}>
                                                    {item.descripcion_larga}
                                                </pre>
                                            </div>
                                        }
                                        {(item.fecha_inicio) &&
                                            <div className="item-name-detalle" style={{ fontSize: '12px' }}>
                                                <span>F. Inicio: {moment(item.fecha_inicio).format('DD-MM-YYYY')}</span>
                                                <span style={{ marginLeft: '10px' }}> F. Término: {moment(item.fecha_fin).format('DD-MM-YYYY')}</span>
                                            </div>
                                        }
                                    </td>
                                    {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) && <td>{item.cant}</td>}
                                    {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) && <td>{item.dias}</td>}
                                    {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item && !viewOptions.ver_solo_titulos) && <td>{item.unidad_medida}</td>}

                                    {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) &&
                                        <td className='text-end'>
                                            <NumberFormat
                                                value={item.precio_unitario || 0}
                                                displayType={'text'}
                                                thousandSeparator={separacion_miles}
                                                decimalSeparator={separacion_decimales}
                                                prefix={`${simbolo} `}
                                            />
                                        </td>
                                    }
                                    {!viewOptions.ocultar_montos_items &&
                                        <td className='text-end'>
                                            <NumberFormat
                                                value={item.pre_subtotal_precio || 0}
                                                displayType={'text'}
                                                thousandSeparator={separacion_miles}
                                                decimalSeparator={separacion_decimales}
                                                prefix={`${simbolo} `}
                                            />
                                        </td>
                                    }

                                    {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) &&
                                        <td className='text-end'>
                                            <NumberFormat
                                                value={item.descuento || 0}
                                                displayType={'text'}
                                                thousandSeparator={separacion_miles}
                                                decimalSeparator={separacion_decimales}
                                                prefix={`${simbolo} `}
                                            />
                                        </td>
                                    }
                                    {!viewOptions.ocultar_montos_items &&
                                        <td className='text-end'>
                                            <NumberFormat
                                                value={item.precio_subtotal || 0}
                                                displayType={'text'}
                                                thousandSeparator={separacion_miles}
                                                decimalSeparator={separacion_decimales}
                                                prefix={`${simbolo} `}
                                            />
                                        </td>
                                    }

                                </tr>
                            ))}
                        </>
                    )
                })}
            </tbody>
        </table >
    )
}